// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2IaAD","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1LnQg"};